import {Injectable} from '@angular/core';
import {RequesterService} from '../../../services/requester.service';
import {LeaderboardModel} from '../models/leaderboard.model';

@Injectable({
    providedIn: 'root'
})
export class LeaderboardService {
    constructor(private requesterService: RequesterService) {
    }

    getLeaderboard(): Promise<LeaderboardModel[]> {
        return this.requesterService.get('getLeaderboard', {})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                }
                return null;
            })
            .catch(e => {
                console.log('Error getLeaderboard >> ', e);
            });
    }


    getLeaderboardWorld(groups = null, type = null): Promise<LeaderboardModel[]> {
        return this.requesterService.get('getLeaderboardWorld', {groups, type})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                }
                return null;
            })
            .catch(e => {
                console.log('Error getLeaderboardWorld >> ', e);
            });
    }
}
